import { ApplicationConfig, APP_INITIALIZER, LOCALE_ID, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEl from '@angular/common/locales/el';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { AuthService } from './core/auth/auth.service';
import { MockAuthService } from './core/auth/mock-auth.service';
import { KeycloakAuthService } from './core/auth/keycloak-auth.service';
import { environment } from '../environments/environment';
import { provideServiceWorker } from '@angular/service-worker';

registerLocaleData(localeEl);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, loadingInterceptor])),
    provideAnimationsAsync(),
    // Greek locale gives '.' thousands / ',' decimals for number/currency pipes
    // app-wide, independent of the UI language toggle (I18nService), which stays
    // separately switchable between en/el for translated text.
    { provide: LOCALE_ID, useValue: 'el' },
    providePrimeNG({
      theme: { preset: Aura, options: { darkModeSelector: '.dark' } },
    }),
    environment.useKeycloak
      ? { provide: AuthService, useClass: KeycloakAuthService }
      : { provide: AuthService, useClass: MockAuthService },
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthService) => () => environment.useKeycloak
        ? (auth as KeycloakAuthService).init()
        : Promise.resolve(true),
      deps: [AuthService],
      multi: true,
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
